import React, { createContext, useState } from "react";
import { IErrorContextType } from "../interfaces/IErrorContextType";
import { IErrorProviderProps } from "../interfaces/IErrorProviderProps";
import { IError } from "../interfaces/IError";

//The error context object holds the latest value of the state.
export const ErrorContext = createContext<IErrorContextType | null>(null);

//This component is responsible for managing the error state and provide a way for other components to set errors.
export const ErrorProvider: React.FC<IErrorProviderProps> = ({ children }) => {
    const [error, setError] = useState<IError | null>(null);
    const value = {
        error,
        setError
    }

    return (
        <ErrorContext.Provider value={value}>
            {children}
        </ErrorContext.Provider>
    );
}